<template lang="html">

    <div class="cover-popup row-center" v-if="showaviso">


        <div class="popup long-form row-start">            

            <h3 class="title-pop">Por favor introduzca su dirección</h3>
            
            <div class="contenedor-input -no-margin">
                <label for="">Tipo de vía*</label>
                <select v-model="data.tipoDeViaCalle" v-validate="'required'" name="via">
                    <option :value="data.id" v-for="data in vias">{{data.descripcion}}</option>
                </select>
                <span :class="['error',{'animated shake' : clicked}]"
                v-if="clicked">{{ errors.first('via') }}</span>
            </div>

            <div class="contenedor-input row-start -with-btn -sixth">
                <label for="">Nombre de la calle*</label>
                <input type="text" v-model="data.direccion" name="calle" v-validate="'required'">
                <span :class="['error',{'animated shake' : clicked}]"
                v-if="clicked">{{ errors.first('calle') }}</span>
            </div>

            <div class="contenedor-input row-start -with-btn -thrid">
                <label for="">Número*</label>
                <input type="text" v-model="data.numeroCalle" name="numero" v-validate="'required'">
                <span :class="['error',{'animated shake' : clicked}]"
                v-if="clicked">{{ errors.first('numero') }}</span>
            </div>

            <div class="contenedor-input row-start -with-btn -thrid">
                <label for="">Escalera</label>
                <input type="text" v-model="data.escaleraCalle">
            </div>

            <div class="contenedor-input row-start -with-btn -thrid">
                <label for="">Piso</label>
                <input type="text" v-model="data.pisoCalle">
            </div>
            <div class="contenedor-input row-start -with-btn -thrid">
                <label for="">Puerta</label>
                <input type="text" v-model="data.puertaCalle">
            </div>
            <div class="contenedor-input row-start -with-btn -thrid">
                <label for="">Letra</label>
                <input type="text" v-model="data.letraCalle">
            </div>


            <div class="contenedor-botones row-center">
                <button class="btn" @click="send" :loading="loading">Enviar</button>
            </div>
        </div>
    </div>


</template>

<script lang="js">

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    import { mapGetters, mapActions } from 'vuex';

    import axios from 'axios';


    export default {
        name: 'popup-direccion',
        mounted(){
            this.getData();
        },
        data() {
            return {
                loading: false,
                clicked : false,
                data: {
                    tipoDeViaCalle : '',
                    direccion : '',
                    numeroCalle : '',
                    escaleraCalle : '',
                    pisoCalle : '',
                    puertaCalle : '',
                    letraCalle : ''
                },
                vias : ''
            }
        },
        methods: {
            ...mapActions(['sendDireccion']),
            send() {
                this.clicked = true;
                this.$validator.validateAll()
                    .then(itsOk => {
                        if (itsOk) {
                            this.loading = true;
                            this.sendDireccion(this.data).then(r => {
                            }).finally(e => {
                                this.loading = false;
                            });
                        }
                    });
            },
            getData(){
                axios.get(`/api/Alumno/dameTiposDeViCalle`).then(result => {
					if (result.data.status == 0) {
                        this.vias = result.data.datos;
					}
				}).catch(error => {
					reject(false);
				});
            }
        },
        computed: {
            ...mapGetters({
                showaviso : 'getshowPopupDireccion'
            })
        },

    }
</script>

<style scoped lang="scss">
    .cover-popup .popup .btn {
        margin-top: 0;
    }

    .contenedor-check {
        margin-top: 20px;
    }

    .contenedor-botones{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/parts/popup-direccion.vue